import { useDispatch, useSelector } from "react-redux";
import Modal from "../UI/Modal";
import { closeEditModal, openViewModal } from "../../store/reducers/frasesRespuesta/frasesRespuesta.reducer";
import { useEffect, useState } from "react";
import {
  updateFraseRespuestaThunk,
  getFrasesRespuestaThunk,
  getFraseRespuestaByIdThunk,
} from "../../store/reducers/frasesRespuesta/frasesRespuesta.thunks";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import { toast } from 'react-toastify';

const FraseRespuestaEditModal = () => {
  const dispatch = useDispatch();
  const {
    editModalOpen,
    selectedFraseRespuesta,
    editLoading,
    editError,
    page,
    search,
  } = useSelector((state) => state.frasesRespuesta);

  const [formData, setFormData] = useState({
    frase: "",
    valor: 0,
    paquete_respuesta: 1,
  });

  useEffect(() => {
    if (selectedFraseRespuesta) {
      setFormData({
        frase: selectedFraseRespuesta.frase || "",
        valor: selectedFraseRespuesta.valor || 0,
        paquete_respuesta: 1, // hardcodeado
      });
    }
  }, [selectedFraseRespuesta, editModalOpen]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "number" ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await dispatch(
      updateFraseRespuestaThunk({
        id: selectedFraseRespuesta.id,
        payload: formData,
      })
    );
    
    if (result.meta.requestStatus === "fulfilled") {
      dispatch(getFrasesRespuestaThunk({ page, search }));
      toast.success('Frase de respuesta actualizada exitosamente');
      // Abrir modal de vista con el registro actualizado
      await dispatch(getFraseRespuestaByIdThunk(selectedFraseRespuesta.id));
      dispatch(openViewModal());
    }
  };

  return (
    <Modal
      open={editModalOpen}
      onClose={() => dispatch(closeEditModal())}
      title="Editar frase respuesta"
      size="lg"
    >
      {editLoading ? (
        <Loader
          center
          type="dots"
          text="Actualizando frase respuesta..."
        />
      ) : (
        <form onSubmit={handleSubmit}>
          {editError && <Alert message={editError} variant="error" />}

          <div className="mb-3">
            <label className="form-label fw-medium">
              Frase <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="frase"
              value={formData.frase}
              onChange={handleChange}
              placeholder="Ingrese la frase"
              rows="4"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-medium">
              Valor <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              className="form-control"
              name="valor"
              value={formData.valor}
              onChange={handleChange}
              placeholder="Ingrese el valor"
              required
            />
            <small className="text-muted">
              Valor numérico asociado a esta frase de respuesta
            </small>
          </div>

         

          <div className="d-flex align-items-center justify-content-end gap-3">
            <button
              type="button"
              className="btn btn-outline-secondary px-20 py-11"
              onClick={() => dispatch(closeEditModal())}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary px-20 py-11">
              Actualizar
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default FraseRespuestaEditModal;
